import type { AppNotificationAction, NotificationLevel } from 'redux/actions/appNotifications';

import {
  CLOSE_AND_CLEAR_APP_NOTIFICATION,
  CLOSE_APP_NOTIFICATION,
  TRIGGER_APP_NOTIFICATION,
} from 'redux/actions/appNotifications';

export type AppNotificationsInitialState = {
  isOpen: boolean;
  text: string | null;
  level: NotificationLevel | null;
};

const appNotificationInitialState: AppNotificationsInitialState = {
  isOpen: false,
  text: null,
  level: null,
};

export default function reducer(
  state: AppNotificationsInitialState = appNotificationInitialState,
  action: AppNotificationAction,
): AppNotificationsInitialState {
  switch (action.type) {
    case CLOSE_APP_NOTIFICATION:
      return { ...state, isOpen: false };
    case CLOSE_AND_CLEAR_APP_NOTIFICATION:
      return { ...state, isOpen: false, text: null, level: null };
    case TRIGGER_APP_NOTIFICATION:
      return { ...state, isOpen: true, text: action.payload.text, level: action.payload.level };
    default:
      return state;
  }
}
